'use client';

import { useCallback, useState } from 'react';
import { useSubscriptionLimits } from './api/subscription';

interface UseFreeRestrictionResult {
  isFreeAccount: boolean;
  blockedFeature: string | null;
  checkAndBlock: (featureName: string, action: () => void) => void;
  clearBlock: () => void;
}

export function useFreeRestriction(groupeId?: number): UseFreeRestrictionResult {
  const limits = useSubscriptionLimits(groupeId);
  const [blockedFeature, setBlockedFeature] = useState<string | null>(null);

  const checkAndBlock = useCallback(
    (featureName: string, action: () => void) => {
      if (limits.isFreeAccount) {
        setBlockedFeature(featureName);
        return;
      }
      action();
    },
    [limits.isFreeAccount],
  );

  const clearBlock = useCallback(() => {
    setBlockedFeature(null);
  }, []);

  return {
    isFreeAccount: limits.isFreeAccount,
    blockedFeature,
    checkAndBlock,
    clearBlock,
  };
}
